import React, { Component } from 'react';
import { withStyles } from 'tss-react/mui';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { indigo } from '@mui/material/colors';
import { connect } from 'react-redux';
import Autocomplete from '@mui/material/Autocomplete';
import { data as aLevel, NOT_QUA } from '@lba-dev/package.local-globals/aLevel';
import { List } from 'immutable';

import McDoStepper from './McDoStepper';
import CardItems from './CancelDialog/CardItems';

const CATEGORY = 1;
const SIGNAL = 2;
const COMMENT = 3;

const styles = {
  input: {
    padding: '16px',
    paddingBottom: 0,
  },
};

const mapStateToProps = (
  { signals, connectedUser, dialog: { contentProps } },
  props
) => ({
  signals: signals.filter(
    (e) => !e.getIn(['hideFor', 'users'], new List())
      .includes(connectedUser._id)
  ),
  ...(contentProps || props),
});

const loadSignals = (filter, signals) =>
  signals
    .filter(data => Object.keys(filter).every(key => filter[key] === data[key]))
    .map(data => ({
      name: data.name,
      color: data.level !== NOT_QUA
        ? aLevel.find(e => e._id === data.level).color
        : indigo,
      type: data.type,
      ref: data.ref,
      data,
    }));

const signalSearch = ({ signals, defaultText: { signalType } }, setSignal) => {
  signals = signals ? signals.toJS() : [];
  const filtered = signalType ?
    signals.filter(e => e.type === signalType) : signals;
  const reduced = filtered.reduce((acc, curr) => {
    const childExist = filtered.some(s => curr.id === s.ref);
    if (!childExist) {
      acc = acc.concat(curr);
    }
    return acc;
  }, []);
  return <Autocomplete
    style={{ width: '50%' }}
    options={reduced}
    getOptionLabel={(signal) => signal.name}
    renderOption={(p, option) => (
      <li {...p}>
        <ListItemText
          variant='caption'
          primary={option.name}
          secondary={option.path}
          onClick={() => setSignal(option)}
        />
      </li>
    )}
    disableListWrap
    renderInput={(params) => (
      <TextField
        {...params}
        label={'Rechercher un signalement'}
        variant="outlined"
      />)}
  />;
};

class SignalSST extends Component {
  state = {
    value: '',
    data: null,
    signal: null,
    currentStep: CATEGORY,
  };

  componentDidMount() {
    const {
      signals,
      defaultText: { signalType },
    } = this.props;
    let newSignals = signals ? signals.toJS() : [];
    if (signalType) {
      newSignals = newSignals.filter(
        s =>
          !s.ref &&
          loadSignals({ type: signalType }, newSignals)
            .map(e => e.ref)
            .includes(s.id)
      );
    }
    this.setState({
      data: loadSignals({ ref: null }, newSignals),
      step: CATEGORY,
    });
  }

  send = () => {
    const { signal, value } = this.state;
    const comment = value.trim();

    if (comment) {
      this.props.callback({
        _id: signal._id,
        comment,
      });
    }
  };

  close = () => this.props.callback();

  generateDialogProps = step => {
    switch (step) {
      case CATEGORY:
        return {
          title: 'Choisissez une catégorie',
        };
      case SIGNAL:
        return {
          title: 'Choisissez un signalement',
        };
      case COMMENT:
        return {
          title: 'Création du signalement',
          maxWidth: 'sm',
          actions: [<Button onClick={this.send} key={0} children="Valider" />],
        };
      default:
        return {
          title: '',
        };
    }
  };

  displayInput = () => {
    const { signal } = this.state;
    const { classes } = this.props;

    return (
      <Grid item xs={12}>
        <Typography children={signal.name} />
        <Input
          className={classes.input}
          multiline
          fullWidth
          rows={10}
          onChange={e => this.setState({ value: e.target.value })}
          placeholder="Commentaire"
        />
      </Grid>
    );
  };

  setStep = (signal, setData) => {
    let { signals } = this.props;

    const {
      defaultText: { signalType },
    } = this.props;

    signals = signals ? signals.toJS() : [];
    this.setState({ signal }, () => {
      const data = loadSignals(
        { ref: signal.id, ...(signalType ? { type: signalType } : {}) },
        signals
      );
      if (!data.length) {
        this.setState({ currentStep: COMMENT });
        setData(signal, COMMENT);
      } else {
        this.setState({ currentStep: SIGNAL });
        setData(data, SIGNAL);
      }
    });
  };

  generateContent = (currentData, currentStep, setData) => {
    const { data } = this.state;
    switch (currentStep) {
      case CATEGORY:
        return (
          <CardItems
            name="data"
            display="name"
            setData={(d, signal) => this.setStep(signal, setData)}
            array={currentData}
          />
        );
      case SIGNAL:
        return (
          <CardItems
            name="data"
            display="name"
            setData={(d, signal) => this.setStep(signal, setData)}
            array={currentData}
          />
        );
      case COMMENT:
        return this.displayInput();
      default:
        if (data) {
          setData(data, CATEGORY);
        }
        return null;
    }
  };

  onRewind = (history) => {
    const lastElem = history[history.length - 1] || {};
    this.setState({ currentStep: lastElem.step || CATEGORY });
  }

  render() {
    return (
      <McDoStepper
        onClose={this.close}
        generateContent={(...args) => (
          <Grid container spacing={2} justifyContent="center">
            {this.generateContent(...args)}
          </Grid>
        )}
        generateDialogProps={this.generateDialogProps}
        customHeader={(setData) =>
          this.state.currentStep !== COMMENT && signalSearch(
            this.props,
            (signal) => this.setStep(signal, setData)
          )}
        onRewind={this.onRewind}
      />
    );
  }
}

export default connect(mapStateToProps)(withStyles(SignalSST, styles));
